export default __webpack_public_path__ + "static/media/Eye-Center-to-Down.85f01bf7.gif";